import React, { useState, useEffect, useCallback } from 'react';

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Sample testimonial data
  const testimonials = [
    {
      id: 1,
      name: "Tummoc",
      role: "CTO, Narayan Mishra",
      content: "Assist Buddi made our support faster and more organized. Managing tickets and chats is now effortless — great tool for any team!",
      avatar: "/assests/img/new_assets/tummoc.webp"
    },
    {
      id: 2,
      name: "Picxele",
      role: "Founder, Rishav Agrawal",
      content: "Excellent support software! Easy to use, responsive, and has improved our customer satisfaction instantly.",
      avatar: "/assests/img/new_assets/picxele.webp"
    },
    {
      id: 3,
      name: "Blu Swap",
      role: "Founder, Debasish Das",
      content: "Excellent support software! Easy to use, responsive, and has improved our customer satisfaction instantly.",
      avatar: "/assests/img/new_assets/test-bluswap.png"
    },
    {
  id: 4,
  name: "Bada Business",
  role: "Founder, Vivek Bindra",
  content: "Assist Buddi Event Software made ticket booking seamless for our events. It simplified the entire process and enhanced our audience experience.",
  avatar: "/assests/img/new_assets/badaBusiness.png"
}
  ];

  // Calculate total slides (each slide shows 2 testimonials)
  const totalSlides = Math.ceil(testimonials.length / 2);
  
  // Create an array of slides (each containing 2 testimonials)
  const slides = [];
  for (let i = 0; i < testimonials.length; i += 2) {
    slides.push(testimonials.slice(i, i + 2));
  }

  const goToSlide = useCallback((index) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex(index);
    setTimeout(() => setIsAnimating(false), 500);
  }, [isAnimating]);

  const nextSlide = useCallback(() => {
    const nextIndex = (currentIndex + 1) % totalSlides;
    goToSlide(nextIndex);
  }, [currentIndex, totalSlides, goToSlide]);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <div className="testimonial-container">
      <h2 className="testimonial-heading">Testimonial</h2>
      
      <div className="testimonial-wrapper">
        <div className="slider-container">
          <div 
            className="slider-track"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
            }}
          >
            {slides.map((slide, slideIndex) => (
              <div key={slideIndex} className="slider-slide">
                {slide.map((testimonial, idx) => (
                  <div key={testimonial.id} className="testimonial-card">
                    {/* Avatar at top:40px, left:-25px overlapping the card */}
                    <div className="avatar-wrapper">
                      <img 
                        src={testimonial.avatar} 
                        alt={testimonial.name}
                        className="author-avatar"
                      />
                    </div>
                    <div className="card-content">
                      <div className="quote-icon">"</div>
                      <p className="testimonial-text">{testimonial.content}</p>
                      <div className="testimonial-author">
                        <div className="author-info">
                          <h4 className="author-name">{testimonial.name}</h4>
                          <p className="author-role">{testimonial.role}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        
        <div className="dot-indicators">
          {Array.from({ length: totalSlides }).map((_, idx) => (
            <button
              key={idx}
              className={`dot ${currentIndex === idx ? 'active' : ''}`}
              onClick={() => goToSlide(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>

      <style jsx>{`
        .testimonial-container {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
        }

        .testimonial-heading {
          text-align: center;
          font-size: 2.5rem;
          font-weight: 600;
          margin-bottom: 48px;
          color: #000000;
          letter-spacing: -0.02em;
        }

        .testimonial-wrapper {
          width: 100%;
          overflow: hidden;
          position: relative;
        }

        .slider-container {
          width: 100%;
          overflow: hidden;
          position: relative;
          margin-bottom: 40px;
        }

        .slider-track {
          display: flex;
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          will-change: transform;
        }

        .slider-slide {
          flex: 0 0 100%;
          display: flex;
          gap: 40px;
          padding: 30px 30px 20px 30px;
          box-sizing: border-box;
        }

        .testimonial-card {
          flex: 1;
          background: #ffffff;
          border-radius: 8px;
          padding: 32px 28px 28px 32px;
          box-shadow: 0 10px 30px -8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border: 1px solid #eef2ff;
          position: relative;
          overflow: visible;
        }

        .testimonial-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.15);
        }

        /* Avatar wrapper - positioned at top:40px, left:-25px overlapping the card */
        .avatar-wrapper {
          position: absolute;
          top: 40px;
          left: -25px;
          z-index: 10;
        }

        /* Square shaped image */
        .author-avatar {
          width: 56px;
          height: 56px;
          border-radius: 0px;
          object-fit: cover;
          border: 3px solid #ffffff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          background: #ffffff;
        }

        .card-content {
          position: relative;
          margin-left: 20px;
        }

        .quote-icon {
          font-size: 48px;
          color: #6366f1;
          opacity: 0.15;
          font-family: Georgia, serif;
          position: absolute;
          top: -15px;
          left: -10px;
          line-height: 1;
          z-index: 0;
        }

        .testimonial-text {
          font-size: 1rem;
          line-height: 1.7;
          color: #1f2937;
          margin-bottom: 24px;
          margin-top: 8px;
          font-style: normal;
          position: relative;
          z-index: 1;
          padding-left: 15px;
        }

        .testimonial-author {
          margin-top: 8px;
          padding-top: 12px;
          border-top: 2px solid #f0f0f0;
          padding-left: 15px;
        }

        .author-info {
          flex: 1;
        }

        .author-name {
          font-size: 1.1rem;
          font-weight: 700;
          color: #111827;
          margin: 0 0 4px 0;
        }

        .author-role {
          font-size: 0.8rem;
          color: #6b7280;
          margin: 0;
        }

        .dot-indicators {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;
          margin-top: 20px;
        }

        .dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #c7d2fe;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          padding: 0;
        }

        .dot:hover {
          background: #818cf8;
          transform: scale(1.2);
        }

        .dot.active {
          width: 24px;
          border-radius: 10px;
          background: linear-gradient(90deg, #6366f1, #8b5cf6);
        }

        /* Responsive Design */
        @media (max-width: 968px) {
          .slider-slide {
            gap: 30px;
            padding: 25px 20px 20px 20px;
          }
        }

        @media (max-width: 768px) {
          .testimonial-container {
            padding: 40px 16px;
          }

          .testimonial-heading {
            font-size: 2rem;
            margin-bottom: 32px;
          }

          .slider-slide {
            gap: 25px;
            padding: 25px 15px 20px 15px;
          }

          .testimonial-card {
            padding: 28px 20px 20px 28px;
          }

          .avatar-wrapper {
            top: 30px;
            left: -20px;
          }

          .author-avatar {
            width: 48px;
            height: 48px;
          }

          .card-content {
            margin-left: 12px;
          }

          .testimonial-text {
            font-size: 0.9rem;
            padding-left: 10px;
          }

          .quote-icon {
            font-size: 40px;
            top: -12px;
            left: -8px;
          }

          .author-name {
            font-size: 1rem;
          }

          .author-role {
            font-size: 0.75rem;
          }

          .testimonial-author {
            padding-left: 10px;
          }
        }

        @media (max-width: 640px) {
          .slider-slide {
            flex-direction: column;
            gap: 40px;
            padding: 25px 15px 20px 15px;
          }

          .testimonial-card {
            width: 100%;
          }

          .card-content {
            margin-left: 8px;
          }
        }
      `}</style>
    </div>
  );
};

export default Testimonial;